import AppUpdates from "components/download/appUpdates";
import Hero from "components/download/hero";
import MobileRow from "components/download/mobileRow";
import Head from "next/head";

import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const Download = () => {
  return (
    <>
      <Head>
        <title>Redact - Download</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Redact - The only platform that allows you to automatically clean up your old posts from services like Twitter, Reddit, Facebook, Discord, and more, all in one place."
        />
        <meta name="keywords" content="redact mass delete privacy free download" />

        <meta property="og:title" content="Redact - Download the app for free today!" />
        <meta
          property="og:description"
          content="The only platform that allows you to automatically clean up your old posts from services like Twitter, Reddit, Facebook, Discord, and more, all in one place."
        />

        <meta property="og:url" content="https://www.redact.dev/download" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <Hero />
        <MobileRow />
        <AppUpdates />
      </StyledWrapper>
    </>
  );
};

export default Download;
